<div class="flex w-full items-center text-base font-semibold">
  <p [class]="textSizeAttribute()">{{ title() }}</p>
</div>

@if (progress()) {
  <sb-progress-bar [level]="progress().level" [theme]="progress().theme || 'white'" [label]="progress().level + '%'" />
}
